import { useState, useContext, useRef } from 'react';

import { useQuery } from '@tanstack/react-query';

import authAxios from '../../components/authAxios';
import {UserContext} from "../../App"

import { TextField, Autocomplete } from "@mui/material";
import {Button} from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';

import { Modal, Radio } from 'antd';
import NumberFormat from "react-number-format";

import './Loans.css'
import { width } from '@fortawesome/free-brands-svg-icons/fa42Group';

const ApplicantFinancialsView = ({ application, setIsModalOpen, txnLines }) => {
    const { pageSize } = useContext(UserContext);
    const validDataRef = useRef(false);

    const [cashFlowCategory, setCashFlowCategory] = useState();

    const [frequency, setFrequency] = useState("MONTHLY");
    const [amount, setAmount] = useState();
    const [subTotal, setSubTotal] = useState();
    const [amountError, setAmountError]=useState(false)

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const { data: cashFlowCategories } = useQuery({
        queryKey: ['cashFlowCategories'],
        queryFn: async () => {
          const response = await authAxios.get(`/loans/cashflow-categories?page_size=${pageSize}`);
          return response.data.results;
        },
    });

    return (
        // <div className="product-details-container application-guarantor-container">
        <div className="inline-table-container product-details-container">

            <table className="styled-table">
                <thead>
                    <tr >
                        <th>#</th>
                        <th>Name</th>
                        <th style={{width: "20%", textAlign: "right"}}>Income</th>
                        <th style={{width: "20%", textAlign: "right"}}>Expense</th>
                        {/* <th></th> */}
                    </tr>
                </thead>
                {application.applicant_financials && application.applicant_financials.map((txnLine, index) => (
                    <tbody key={index}>
                        <tr>
                            <td>{txnLine.id}</td>
                            <td>{txnLine.category_name}</td>
                            <td style={{width: "20%", textAlign: "right"}}>{txnLine.category_type==="INCOME"?Number(txnLine.amount).toLocaleString():""}</td>
                            <td style={{width: "20%", textAlign: "right"}}>{txnLine.category_type==="EXPENSE"?Number(txnLine.amount).toLocaleString():""}</td>
                            {/* <td>
                                <IconButton 
                                    size="small">
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </td> */}
                        </tr>
                    </tbody>
                ))}
            </table>
        </div>

    );
};

export default ApplicantFinancialsView;
